import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {Equipment, EquipmentGroup} from "../../api/model/equipment";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
  EquipmentAddEditDialogComponent,
  EquipmentAddEditDialogData
} from "../../equipment/add-edit-dialog/equipment-add-edit-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Project} from "../../api/model/project";

@Component({
  selector: 'app-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrl: './equipment-list.component.sass'
})
export class PurchaseOrderEquipmentListComponent implements OnInit, OnChanges {
  @Input() equipment!: Equipment[];
  @Output() changed = new EventEmitter<Equipment[]>();
  @Output() checked = new EventEmitter<Equipment[]>();
  displayedColumns: string[] = ['select', 'manufacturer', 'sku', 'model', 'qty', 'status', 'project'];
  dataSource = new MatTableDataSource<Equipment>();
  selection = new SelectionModel<Equipment>(true, []);
  private dialogRef: MatDialogRef<any> | undefined;

  constructor(
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.dataSource.data = this.equipment;
  }

  ngOnChanges(): void {
    this.ngOnInit();
    this.selection.selected
      .filter(e => !this.equipment.includes(e))
      .forEach(e => this.selection.deselect(e));
    this.emitSelection();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.emitSelection();
      return;
    }

    this.selection.select(...this.dataSource.data);
    this.emitSelection();
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Equipment): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.manufacturer} ${row.sku} ${row.model}`;
  }

  openEditDialog(equipment: Equipment): void {
    const dialogData: EquipmentAddEditDialogData = {
      project: equipment.project,
      equipment: equipment,
      group: EquipmentGroup.PROJECT
    }
    const dialogRef = this.dialog.open(EquipmentAddEditDialogComponent,
      {maxWidth: "97vw", data: dialogData, closeOnNavigation: false});
    this.dialogRef = dialogRef;
    console.log("PurchaseOrderEquipmentListComponent dialog being opened dialogRef", this.dialogRef);
    dialogRef.afterClosed().subscribe(result => {
      console.log("PurchaseOrderEquipmentListComponent afterClosed result", result);
      this.dialogRef = undefined;
      if (result)
        this.changed.emit([equipment]);
    });
  }

  selectionChange(row: Equipment) {
    this.selection.toggle(row);
    this.emitSelection();
  }

  copyToClipboard(selected: Equipment[]) {
    const content = selected
      .map(eq => {
        return `${eq.sku}\t${eq.model}\t${eq.quantity}`;
      })
      .join('\n');

    navigator.clipboard.writeText(content)
      .then(value => {
        console.log("PurchaseOrderEquipmentListComponent copyToClipboard", selected, content);
        this._snackBar.open(`Copied ${selected.length} items to clipboard!`,
          undefined, {duration: 5000});
      }).catch(reason => {
      console.error("PurchaseOrderEquipmentListComponent copyToClipboard", reason, content);
      this._snackBar.open('Could not copy to clipboard... ' + reason,
        undefined, {duration: 5000});
    });
  }

  topLevelProjects(eq: Equipment): Project[] {
    const assigned = eq.assignedProjects.filter(p => !p.parentId);
    if (assigned.length === 0) {
      return [eq.project];
    }
    return assigned;
  }

  private emitSelection() {
    this.checked.emit(this.selection.selected);
  }
}
